import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ClientPaymentsDraftTable from "./components/ClientPaymentsDraftTable";

export function ClientPaymentsDraft() {
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Klientutbetalningar utkast</Typography>
            </Box>
            <ClientPaymentsDraftTable />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
